import { setGLTFLoader } from '@utils/sceneObjects/setGLTFLoader'
import type { GLTF } from 'three/examples/jsm/loaders/GLTFLoader'

const urlCache = new Map<string, Promise<GLTF>>()
let sharedLoader: ReturnType<typeof setGLTFLoader> | null = null

export async function getSharedGLTFLoader() {
  if (!sharedLoader) {
    sharedLoader = setGLTFLoader()
  }
  return sharedLoader
}

/** Carga GLB por URL con deduplicación (misma URL = una sola descarga + decode). */
export async function loadGlbCached(url: string): Promise<GLTF> {
  const key = String(url || '').trim()
  if (!key) {
    throw new Error('loadGlbCached: empty url')
  }

  const existing = urlCache.get(key)
  if (existing) return existing

  const promise = (async () => {
    const loader = await getSharedGLTFLoader()
    return loader.loadAsync(key)
  })()

  urlCache.set(key, promise)
  promise.catch(() => {
    urlCache.delete(key)
  })
  return promise
}

export function clearGlbUrlCache(): void {
  urlCache.clear()
}

export function isGlbUrlCached(url: string): boolean {
  return urlCache.has(String(url || '').trim())
}
